const NAME = 'OLARK';
const CNameMapping = {
  [NAME]: NAME,
  Olark: NAME,
  olark: NAME,
};

export { NAME, CNameMapping };
